import { apiRequestActionType, apiSuccessActionType, apiErrorActionType } from 'utils/API/action-types'

export const UNITIES = 'UNITIES'

export const REQUEST_UNITIES = apiRequestActionType(UNITIES)
export const SUCCESS_UNITIES = apiSuccessActionType(UNITIES)
export const ERROR_UNITIES = apiErrorActionType(UNITIES)
